<!--  -->
<template>
  <div :class="[this.$root.whatEev == 'miniprogram' ? 'minichat' : '']">
    <div class="home" :class="{ inApp: $root.$data.isApp, fix: searchVal }">
      <div class="top-head">
        <div class="title">
          <img
            v-if="this.$root.whatEev != 'miniprogram'"
            class="back"
            @click="back"
            src="../../assets/img/majorSenior/back.png"
            alt=""
          />
          <h1>高分学长学姐为您提供1v1个性化授课</h1>
          <h2>助你高效复习 顺利上岸</h2>
          <h2>15000+ 学长学姐为您保驾护航</h2>
          <div class="search">
            <van-field
              v-model.trim="searchVal"
              type="input"
              clearable
              maxlength="20"
              @input="change"
              placeholder="请输入您的目标院校"
            />
          </div>
        </div>
        <div class="schoolList" v-if="searchVal" @click.stop="closeBg($event)">
          <div>
            <div
              :class="selected === index ? 'active' : ''"
              @click="addClass(index, item.name)"
              v-for="(item, index) in searchList"
              :key="index"
            >
              {{ item.name }}
            </div>
            <EmptyData :emptyName="'noEvaluation'" v-if="searchVal && !searchList.length" />
          </div>
        </div>
      </div>
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="listItem" v-for="(item, index) in schoolList" :key="index">
          <schoolCard :shchoolInfo="item" @click.native="majorSenior(item.name)" />
        </div>
      </van-list>
      <div class="fix-img" @click="openChat">
        <img src="../../assets/img/majorSenior/kspp.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { reqSchoolList } from '@/api/majorSenior';
import { seniorOpenChat, gioPlatform } from '@/utils/tools';
import EmptyData from '@/components/emptyData/emptyData.vue';
import schoolCard from './components/schoolCard.vue';
import wx from 'weixin-js-sdk';

export default {
  components: {
    schoolCard,
    EmptyData,
  },
  data() {
    return {
      searchVal: '',
      pageNum: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      searchList: [],
      schoolList: [],
      selected: -1,
    };
  },
  computed: {},
  watch: {},
  methods: {
    back() {
      this.$router.push('/exam25?code=10');
    },
    // 列表加载
    onLoad() {
      setTimeout(() => {
        this.getSeniorList(this.searchVal, this.pageNum, this.pageSize);
        this.loading = true;
      }, 500);
    },
    blur() {},
    change() {
      // this.schoolList = [];
      this.searchList = [];
      this.getSearchList(this.searchVal, 1, 20);
    },
    addClass(index, name) {
      this.selected = index;
      this.majorSenior(name);
    },
    majorSenior(name) {
      const routeUrl = this.$router.resolve({
        path: '/ark/majorSenior',
        query: { name },
      });
      const { isApp = false } = this.$root.$data;
      if (isApp) {
        this.$sendToApp(
          'openNewWebView',
          {
            url: `${window.location.origin}${routeUrl.resolved.fullPath}`,
          },
          false,
        );
      } else {
        window.top.open(routeUrl.resolved.fullPath);
      }
      this.schoolClick_event(name);
    },
    // 快速匹配
    openChat() {
      if (this.$root.whatEev == 'miniprogram') {
        wx.miniProgram.navigateTo({ url: '/subPackages/seniormantisChat/seniormantisChat' });
      } else {
        seniorOpenChat(this);
      }
    },
    async getSeniorList(searchVal, pageNum, pageSize) {
      const res = await reqSchoolList(searchVal, pageNum, pageSize);
      if (res?.code === 0) {
        this.loading = false;
        this.schoolList = this.schoolList.concat(res?.data?.data);
        this.pageNum += 1;
        // 如果加载完毕，显示没有更多了
        const { total } = res.data;
        if (this.schoolList.length >= total) {
          this.finished = true;
        }
      }
    },
    async getSearchList(searchVal, pageNum, pageSize) {
      if (!searchVal) return;
      const res = await reqSchoolList(searchVal, pageNum, pageSize);
      this.searchList = [];
      if (res?.code === 0) {
        this.searchList = this.searchList.concat(res?.data?.data);
      }
    },
    schoolClick_event(name) {
      // eslint-disable-next-line no-undef
      gio('track', 'schoolClick_event', {
        SchoolName_var: name, // 广告位置
        PlatformType_var: gioPlatform(),
      });
    },
    closeBg(el) {
      if (el.target === el.currentTarget) {
        this.searchVal = '';
        this.searchList = [];
      }
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>

.home.inApp {
  padding-top: 260px;
  .top-head {
    height: 255px;
    .back {
      display: none;
    }
  }
  .schoolList {
    top: 255px;
  }
}
.home.fix {
  position: fixed;
}
.home {
  position: relative;
  min-height: 100vh;
  padding-top: 363px;
  background: #f7f8fc;
}
.top-head {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 750px;
  height: 350px;
  background: linear-gradient(90deg, #fe7f42 0%, #ff6b00 100%);
  .title {
    width: 750px;
    height: 100%;
    padding: 36px 36px 18px 36px;
    background: url('../../assets/img/majorSenior/bg1.png') no-repeat;
    background-size: 100%;
    img {
      width: 43px;
      height: 43px;
      margin-bottom: 43px;
    }
    h1 {
      color: #fff;
      font-weight: 500;
      font-size: 31px;
      line-height: 43px;
    }
    h2 {
      color: #fff;
      font-weight: 400;
      font-size: 25px;
      line-height: 36px;
    }
    .search {
      position: relative;
      margin: 25px 0 0 0;
    }
    .search::before {
      position: absolute;
      top: 18px;
      left: 22px;
      z-index: 10;
      display: block;
      width: 29px;
      height: 29px;
      background: url('../../assets/img/majorSenior/search.png') no-repeat;
      background-size: 100%;
      content: '';
    }
  }
  .schoolList {
    position: absolute;
    top: 350px;
    right: 0;
    left: 0;
    z-index: 100000;
    width: 750px;
    height: calc(100vh - 350px);
    margin: 0 auto;
    overflow: hidden;
    background: rgba($color: #000, $alpha: 0.5);
    > div {
      height: 740px;
      overflow-y: auto;
      background: #fff;
      border-radius: 0 0 36px 36px;

      > div {
        padding: 0 0 0 36px;
        color: #333;
        font-weight: 400;
        font-size: 25px;
        line-height: 91px;
      }
    }
    > div.active {
      color: #ff7f41;
      background: #fff3ee;
    }
  }
}
.listItem {
  display: flex;
  align-items: center;
  width: 678px;
  margin: 22px auto;
  margin-top: 22px;
  // padding: 24px 0 24px 24px;
  background-color: #fff;
  border-radius: 14px;

  .badgeUrl {
    width: 134px;
    height: 134px;
    padding: 26px;
    border: 2px solid #dedede;
    border-radius: 14px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .schoolInfo {
    margin-left: 30px;

    .schoolTitle {
      color: #1f1f39;
      font-weight: bold;
      font-size: 29px;
      line-height: 48px;
    }

    .schoolAddress {
      margin: 15px 0;
      color: #666;
      font-size: 22px;
      line-height: 32px;
    }

    .schoolType {
      display: flex;
      flex-wrap: wrap;
      div:first-child {
        margin-left: 0;
      }

      div {
        margin: 7px;
        padding: 2px 10px;
        color: var(--themeColor);
        font-size: 22px;
        line-height: 40px;
        text-align: center;
        background: #fef5f1;
        border-radius: 10px;
      }
    }
  }
}
.fix-img {
  position: fixed;
  right: 22px;
  bottom: 56px;
  z-index: 200;
  width: 139px;
  height: 139px;
  img {
    width: 139px;
    height: 139px;
  }
}
.minichat {
  .home  {
    padding-top: 260px;
    .top-head {
      height: auto;
    }
  }
  .schoolList{
    top: 255px;
  }

}
::v-deep .van-field__control {
  width: 339px;
  height: 32.5px;
  padding-left: 32.5px;
  color: #999;
  font-weight: 400;
  font-size: 14px;
  background: #fff;
  border-radius: 7px;
}
::v-deep .van-cell {
  padding: 0;
  border-radius: 7px;
}
::v-deep .emptyIndent {
  height: 400px;
  margin-top: 100px;
}
::v-deep .emptyIndent .hide {
  display: none;
}
</style>
